const a = (e) => ({
  logos: e.default_logo.images.map((t) => ({
    alt_text: t.alt_text,
    viewport: t.viewport,
    url: t.image.url
  })),
  componentType: "site_logo"
});
export {
  a as default
};
//# sourceMappingURL=sitelogo-transformer.js.map
